import FileFilled from "../../../assets/File-filled.svg";

/**
 * Updates a file in the files array by id and returns the new array.
 * @param {Array} files - Array of file objects.
 * @param {Object} updatedFile - The file object with updated properties.
 * @returns {Array} - New array with the updated file.
 */
export function updateFileInArray(files, updatedFile) {
    if (!Array.isArray(files)) return files;
    return files.map((file) => (file.id === updatedFile.id ? updatedFile : file));
}

/**
 * Removes a file from the files array by id and returns the new array.
 * @param {Array} files - Array of file objects.
 * @param {string} id - The id of the file to remove.
 * @returns {Array} - New array without the removed file.
 */
export function removeFileFromArray(files, id) {
    if (!Array.isArray(files)) return files;
    return files.filter((file) => file.id !== id);
}

export const getThumbnailSrc = (currentAttachment) => {
    if (["png", "jpg", "jpeg", "gif", "jfif", "jpe", "bmp"].includes(currentAttachment.extension)) {
        return `data:${currentAttachment.fileType};base64,${currentAttachment.data}`;
    } else {
        return FileFilled;
    }
};
